<template>
    <v-card :elevation="1" class="background-2" width="100%">

        <v-card-text v-if="isLoaded">
            <v-row class="mx-0">
                <!-- Pannello sinistro: Campi configurati -->
                <v-col cols="6">
                    <v-card outlined class="pa-2" style="max-height: 700px; overflow: auto; padding-bottom: 60% !important;">
                        <v-card-title class="text-subtitle-1">
                            Campi Configurati
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="addNewGroup">
                                Nuovo Gruppo
                            </v-btn>
                        </v-card-title>

                        <v-divider class="mb-3"></v-divider>

                        <!-- Gruppi e campi configurati -->
                        <draggable 
                            v-model="groups" 
                            :group="{ 
                                name: 'groups-only',
                                pull: true,
                                put: function(to, from) {
                                    // Permettiamo solo il drag and drop tra gruppi dello stesso livello
                                    return from.options.group.name === 'groups-only';
                                }
                            }"
                            class="group-container"
                            handle=".group-drag-handle"
                            ghostClass="ghost-element"
                            chosenClass="chosen-element"
                            :swapThreshold="0.50"
                            @change="updateOrders">

                            <v-card v-for="(group, groupIndex) in groups"
                                :key="group.id"
                                outlined
                                class="mb-3">
                                <v-card-title class="py-2 pl-2">
                                    <div class="d-flex w100p align-center">
                                        <div class="group-drag-handle d-flex align-center">
                                            <v-icon class="pr-2">mdi-drag-vertical-variant</v-icon>
                                        </div>
                                        
                                        <!-- Indicatore colore del gruppo -->
                                        <v-menu
                                            v-model="colorMenus[group.id]"
                                            :close-on-content-click="false"
                                            offset-y
                                            transition="slide-y-transition">
                                            <template v-slot:activator="{ on: menuOn, attrs }">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on: tooltipOn }">
                                                        <v-btn
                                                            icon
                                                            small
                                                            v-bind="attrs"
                                                            v-on="{ ...tooltipOn, ...menuOn }"
                                                            class="mr-2 no-drag"
                                                            :style="getBackgroundColorHex(group.background_color) ? `background-color: ${getBackgroundColorHex(group.background_color)} !important` : ''"
                                                            :color="!group.background_color ? 'grey lighten-2' : ''">
                                                            <v-icon 
                                                                small
                                                                >
                                                                mdi-palette
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Colore di sfondo del gruppo</span>
                                                </v-tooltip>
                                            </template>
                                            <v-card>
                                                <v-card-text class="pa-2">
                                                    <v-color-picker
                                                        :value="getColorPickerValue(group.background_color)"
                                                        @input="updateGroupBackgroundColor(group, $event)"
                                                        hide-mode-switch
                                                        mode="hexa"
                                                        :swatches="colorSwatches"
                                                        show-swatches
                                                        width="300"></v-color-picker>
                                                </v-card-text>
                                                <v-divider></v-divider>
                                                <v-card-actions>
                                                    <v-btn 
                                                        text 
                                                        small 
                                                        @click="removeGroupBackgroundColor(group)">
                                                        Rimuovi colore
                                                    </v-btn>
                                                    <v-spacer></v-spacer>
                                                    <v-btn 
                                                        text 
                                                        small 
                                                        color="primary"
                                                        @click="colorMenus[group.id] = false">
                                                        OK
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-menu>
                                        
                                        <v-text-field
                                            v-model="group.label"
                                            dense
                                            outlined
                                            hide-details
                                            class="no-drag-input flex-grow-1"
                                        ></v-text-field>
                                        
                                        <!-- Pannello impostazioni gruppo -->
                                        <div class="d-flex align-center ml-2">
                                            <v-menu
                                                v-model="settingsMenus[group.id]"
                                                :close-on-content-click="false"
                                                offset-y
                                                left
                                                transition="slide-y-transition"
                                                max-width="320px">
                                                <template v-slot:activator="{ on: menuOn, attrs }">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on: tooltipOn }">
                                                            <v-btn
                                                                icon
                                                                v-bind="attrs"
                                                                v-on="{ ...tooltipOn, ...menuOn }"
                                                                class="no-drag">
                                                                <v-badge
                                                                    :value="group.collapsible || group.collapsed_by_default"
                                                                    dot
                                                                    color="primary"
                                                                    offset-x="10"
                                                                    offset-y="10">
                                                                    <v-icon>mdi-cog</v-icon>
                                                                </v-badge>
                                                            </v-btn>
                                                        </template>
                                                        <span>Impostazioni del gruppo</span>
                                                    </v-tooltip>
                                                </template>
                                                <v-card class="round-card">
                                                    <v-card-title class="text-subtitle-1 pb-2">
                                                        <p>Impostazioni Gruppo</p>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            icon
                                                            small
                                                            @click="settingsMenus[group.id] = false">
                                                            <v-icon small>mdi-close</v-icon>
                                                        </v-btn>
                                                    </v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-card-text class="pa-3">
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-switch
                                                                    v-model="group.collapsible"
                                                                    inset
                                                                    hide-details="auto"
                                                                    class="mt-0 mb-3">
                                                                    <template v-slot:label>
                                                                        <div>
                                                                            <div class="text-body-2">Gruppo espandibile</div>
                                                                            <div class="text-caption grey--text">Permette di espandere o comprimere il gruppo</div>
                                                                        </div>
                                                                    </template>
                                                                </v-switch>
                                                            </v-col>
                                                            
                                                            <v-col cols="12" v-if="group.collapsible">
                                                                <v-switch
                                                                    v-model="group.collapsed_by_default"
                                                                    inset
                                                                    hide-details="auto"
                                                                    color="orange"
                                                                    class="mt-0 mb-3">
                                                                    <template v-slot:label>
                                                                        <div>
                                                                            <div class="text-body-2">Chiuso di default</div>
                                                                            <div class="text-caption grey--text">Il gruppo sarà chiuso all'apertura</div>
                                                                        </div>
                                                                    </template>
                                                                </v-switch>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-menu>
                                            
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn 
                                                        icon 
                                                        @click.stop="removeGroup(group)" 
                                                        color="error" 
                                                        class="no-drag"
                                                        v-bind="attrs"
                                                        v-on="on">
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Rimuovi Gruppo</span>
                                            </v-tooltip>
                                            
                                            <v-btn 
                                                icon 
                                                @click.stop="toggleExpandGroup(group)" 
                                                class="ml-1">
                                                <v-icon>{{ isExpandedGroup(group) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-card-title>

                                <v-slide-y-transition>
                                    <div v-show="isExpandedGroup(group)">
                                        <v-divider></v-divider>
                                        <draggable
                                            v-model="group.fields"
                                            :group="{ 
                                                name: 'fields', 
                                                pull: true, 
                                                put: function(to, from) {
                                                    // Accetta solo elementi dal gruppo 'fields'
                                                    return from.options.group.name === 'fields';
                                                }
                                            }"
                                            class="pa-3 group-fields-container"
                                            handle=".drag-handle"
                                            ghostClass="ghost-element"
                                            chosenClass="chosen-element"
                                            :swapThreshold="0.50"
                                            @change="updateFieldOrder(group)">

                                            <v-card v-for="field in group.fields"
                                                :key="field.id"
                                                outlined
                                                class="field-card mb-2">
                                                <v-row class="ma-0 px-2 py-1">
                                                    <v-col cols="7" class="pa-2 d-flex align-center">
                                                        <v-icon class="pr-2 drag-handle">mdi-drag-vertical-variant</v-icon>
                                                        <span class="drag-handle">{{ field.label }} {{ field.customfield ? '(CP)' : '' }}</span>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon 
                                                                    v-if="field.always_required === true" 
                                                                    class="pl-2" 
                                                                    color="error"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                >mdi-asterisk</v-icon>
                                                            </template>
                                                            <span>Obbligatorio</span>
                                                        </v-tooltip>

                                                    </v-col>

                                                    <template v-if="field.always_required === false && (!field.customfield || field.type !== 'pivot')">

                                                        <v-col cols="3" class="pa-2">
                                                            <v-checkbox v-if="field.type !== 'boolean'"
                                                                v-model="field.required"
                                                                label="Obbligatorio"
                                                                hide-details
                                                                class="ma-0 no-drag"
                                                            ></v-checkbox>
                                                        </v-col>
                                                        <v-col cols="1" class="pa-2">
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn 
                                                                        icon 
                                                                        small 
                                                                        @click="handleFieldRemoval(field, groupIndex)" 
                                                                        color="error"
                                                                        v-bind="attrs"
                                                                        v-on="on">
                                                                        <v-icon>mdi-delete</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Rimuovi Campo</span>
                                                            </v-tooltip>
                                                        </v-col>

                                                    </template>
                                                    <template v-else>
                                                        <v-col cols="4" class="pa-2">
                                                        </v-col>
                                                    </template>

                                                    <v-col cols="1" class="pa-2">
                                                        <v-btn icon small @click.stop="toggleExpand(field)" color="primary">
                                                            <v-icon>{{ isExpanded(field) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>

                                                <div v-show="isExpanded(field)" class="expand-content">
                                                    <v-divider></v-divider>
                                                    <v-row class="ma-0 pa-2">
                                                        <v-col cols="12" class="pa-2" v-if="!field.customfield || field.type !== 'pivot'">
                                                            <v-text-field
                                                                v-if="hasGeneralTypeDefault(field)"
                                                                :value="generalTypeDefaultText"
                                                                label="Valore Default"
                                                                dense
                                                                outlined
                                                                hide-details
                                                                disabled
                                                                class="mb-2"
                                                            ></v-text-field>
                                                            <v-text-field
                                                                v-else
                                                                v-model="field.default"
                                                                label="Valore Default"
                                                                dense
                                                                outlined
                                                                hide-details
                                                                class="mb-2"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" class="pa-2 pt-0">
                                                            <v-switch
                                                                v-model="field.permissions.show_exclude"
                                                                @change="applyRolePermissions(field)"
                                                                :label="'Escludi questi ruoli dalla visualizzazione di questo campo: ' + (field.permissions.show_exclude ? 'Si' : 'No')"
                                                                inset
                                                                hide-details
                                                                class="mb-2 ma-0"
                                                            ></v-switch>
                                                            <v-select
                                                                v-model="field.permissions.show"
                                                                @change="applyRolePermissions(field)"
                                                                :items="roles"
                                                                :label="rolePermissionLabel('show', field.permissions)"
                                                                multiple
                                                                dense
                                                                chips
                                                                small-chips
                                                                :menu-props="{'offset-y': true}"
                                                                outlined
                                                                hide-details
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="12" class="pa-2">
                                                            <v-switch
                                                                v-model="field.permissions.edit_exclude"
                                                                @change="applyRolePermissions(field)"
                                                                :label="'Escludi questi ruoli dalla modifica di questo campo: ' + (field.permissions.edit_exclude ? 'Si' : 'No')"
                                                                inset
                                                                hide-details
                                                                class="mb-2 ma-0"
                                                            ></v-switch>
                                                            <v-select
                                                                v-model="field.permissions.edit"
                                                                @change="applyRolePermissions(field)"
                                                                :items="roles"
                                                                :label="rolePermissionLabel('edit', field.permissions)"
                                                                multiple
                                                                dense
                                                                chips
                                                                small-chips
                                                                :menu-props="{'offset-y': true}"
                                                                outlined
                                                                hide-details
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="12" class="pa-2">
                                                            <v-switch
                                                                v-model="field.permissions.edit_empty_only_exclude"
                                                                :label="'Escludi questi ruoli dalla modifica solo se vuoto: ' + (field.permissions.edit_empty_only_exclude ? 'Si' : 'No')"
                                                                inset
                                                                hide-details
                                                                class="mb-2 ma-0"
                                                            ></v-switch>
                                                            <v-select
                                                                v-model="field.permissions.edit_empty_only"
                                                                @change="applyRolePermissions(field)"
                                                                :items="roles"
                                                                :label="rolePermissionLabel('edit_empty_only', field.permissions)"
                                                                multiple
                                                                dense
                                                                chips
                                                                small-chips
                                                                :menu-props="{'offset-y': true}"
                                                                outlined
                                                                hide-details
                                                            ></v-select>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-card>
                                        </draggable>
                                    </div>
                                </v-slide-y-transition>
                            </v-card>
                        </draggable>

                        <!-- Campi non raggruppati -->
                        <v-card outlined class="mt-3 pa-2">
                            <v-card-title class="text-subtitle-1">
                                Campi non raggruppati
                            </v-card-title>

                            <v-divider class="mb-3"></v-divider>
                            <draggable
                                v-model="ungroupedFields"
                                :group="{ 
                                    name: 'fields',
                                    pull: true, 
                                    put: function(to, from) {
                                        // Permettiamo solo il drop di elementi che non sono gruppi
                                        return from.options.group.name !== 'groups-only';
                                    }
                                }"
                                handle=".drag-handle"
                                class="pa-2 group-fields-container"
                                ghostClass="ghost-element"
                                chosenClass="chosen-element"
                                :swapThreshold="0.50">

                                <v-card v-for="field in ungroupedFields"
                                    :key="field.id"
                                    outlined
                                    class="field-card cursor-pointer mb-2">
                                    <v-row class="ma-0 px-2 py-1">
                                        <v-col cols="7" class="pa-2 d-flex align-center">
                                            <v-icon class="pr-2 drag-handle">mdi-drag-vertical-variant</v-icon>
                                            <span class="drag-handle">{{ field.label }} {{ field.customfield ? '(CP)' : '' }}</span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon 
                                                        v-if="field.always_required === true" 
                                                        class="pl-2" 
                                                        color="error"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >mdi-asterisk</v-icon>
                                                </template>
                                                <span>Obbligatorio</span>
                                            </v-tooltip>
                                        </v-col>
                                        <template v-if="field.always_required === false && (!field.customfield || field.type !== 'pivot')">

                                            <v-col cols="3" class="pa-2">
                                                <v-checkbox v-if="field.type !== 'boolean'"
                                                    v-model="field.required"
                                                    label="Obbligatorio"
                                                    hide-details
                                                    class="ma-0 no-drag"
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col cols="1" class="pa-2">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn 
                                                            icon 
                                                            small 
                                                            @click="handleFieldRemoval(field)" 
                                                            color="error"
                                                            v-bind="attrs"
                                                            v-on="on">
                                                            <v-icon>mdi-delete</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Rimuovi Campo</span>
                                                </v-tooltip>
                                            </v-col>
                                        </template>
                                        <template v-else>
                                            <v-col cols="4" class="pa-2">
                                            </v-col>
                                        </template>

                                        <v-col cols="1" class="pa-2">
                                            <v-btn icon small @click.stop="toggleExpand(field)" color="primary">
                                                <v-icon>{{ isExpanded(field) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                    <div v-show="isExpanded(field)" class="expand-content">
                                        <v-divider></v-divider>
                                        <v-row class="ma-0 pa-2">
                                            <v-col cols="12" class="pa-2" v-if="!field.customfield || field.type !== 'pivot'">
                                                <v-text-field
                                                    v-if="hasGeneralTypeDefault(field)"
                                                    :value="generalTypeDefaultText"
                                                    label="Valore Default"
                                                    dense
                                                    outlined
                                                    hide-details
                                                    disabled
                                                    class="mb-2 ma-0"
                                                ></v-text-field>
                                                <v-text-field
                                                    v-else
                                                    v-model="field.default"
                                                    label="Valore Default"
                                                    dense
                                                    outlined
                                                    hide-details
                                                    class="mb-2 ma-0"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pa-2 pt-0">
                                                <v-switch
                                                    v-model="field.permissions.show_exclude"
                                                    @change="applyRolePermissions(field)"
                                                    :label="'Escludi questi ruoli dalla visualizzazione di questo campo: ' + (field.permissions.show_exclude ? 'Si' : 'No')"
                                                    inset
                                                    hide-details
                                                    class="mb-2 ma-0"
                                                ></v-switch>
                                                <v-select
                                                    v-model="field.permissions.show"
                                                    @change="applyRolePermissions(field)"
                                                    :items="roles"
                                                    :label="rolePermissionLabel('show', field.permissions)"
                                                    multiple
                                                    dense
                                                    chips
                                                    small-chips
                                                    :menu-props="{'offset-y': true}"
                                                    outlined
                                                    hide-details
                                                ></v-select>
                                            </v-col>
                                            <v-col cols="12" class="pa-2">
                                                <v-switch
                                                    v-model="field.permissions.edit_exclude"
                                                    @change="applyRolePermissions(field)"
                                                    :label="'Escludi questi ruoli dalla modifica di questo campo: ' + (field.permissions.edit_exclude ? 'Si' : 'No')"
                                                    inset
                                                    hide-details
                                                    class="mb-2 ma-0"
                                                ></v-switch>
                                                <v-select
                                                    v-model="field.permissions.edit"
                                                    @change="applyRolePermissions(field)"
                                                    :items="roles"
                                                    :label="rolePermissionLabel('edit', field.permissions)"
                                                    multiple
                                                    dense
                                                    chips
                                                    small-chips
                                                    :menu-props="{'offset-y': true}"
                                                    outlined
                                                    hide-details
                                                ></v-select>
                                            </v-col>
                                            <v-col cols="12" class="pa-2">
                                                <v-switch
                                                    v-model="field.permissions.edit_empty_only_exclude"
                                                    :label="'Escludi questi ruoli dalla modifica solo se vuoto: ' + (field.permissions.edit_empty_only_exclude ? 'Si' : 'No')"
                                                    inset
                                                    hide-details
                                                    class="mb-2 ma-0"
                                                ></v-switch>
                                                <v-select
                                                    v-model="field.permissions.edit_empty_only"
                                                    @change="applyRolePermissions(field)"
                                                    :items="roles"
                                                    :label="rolePermissionLabel('edit_empty_only', field.permissions)"
                                                    multiple
                                                    dense
                                                    chips
                                                    small-chips
                                                    :menu-props="{'offset-y': true}"
                                                    outlined
                                                    hide-details
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-card>
                            </draggable>

                            <!-- Aggiungi questi pulsanti alla fine della card "Campi non raggruppati" -->
                            <v-card-actions class="pt-3">
                                <v-row no-gutters>
                                    <v-col cols="6" class="pr-1">
                                        <v-btn 
                                            block
                                            color="primary"
                                            @click="addAllFields"
                                            :disabled="!availableFields.length">
                                            <v-icon left>mdi-arrow-all</v-icon>
                                            Aggiungi tutto
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6" class="pl-1">
                                        <v-btn 
                                            block
                                            color="error"
                                            @click="clearAllUngroupedFields"
                                            :disabled="!ungroupedFields.length">
                                            <v-icon left>mdi-delete-sweep</v-icon>
                                            Svuota tutto
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-actions>
                        </v-card>
                    </v-card>
                </v-col>

                <!-- Pannello destro: Campi disponibili -->
                <v-col cols="6">
                    <v-card outlined class="pa-2" style="max-height: 700px; overflow: auto; padding-bottom: 60% !important;">
                        <v-card-title class="text-subtitle-1">
                            Campi Disponibili
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="searchField"
                                append-icon="mdi-magnify"
                                label="Cerca"
                                hide-details
                                dense
                                outlined
                                clearable
                                style="max-width: 240px"
                            ></v-text-field>
                        </v-card-title>
                        <v-divider class="mb-3"></v-divider>
                        <draggable
                            :list="availableFields"
                            :group="{ 
                                name: 'fields', 
                                pull: 'clone', 
                                put: false,
                                revertClone: true
                            }"
                            :sort="false"
                            :clone="cloneField">
                            <template v-for="field in availableFields">
                                <v-card 
                                    v-if="matchesSearch(field)"
                                    :key="field.id"
                                    class="cursor-pointer mb-1"
                                    outlined>
                                    <v-card-text class="py-2">
                                        <v-icon class="pr-2 drag-handle">mdi-drag-vertical-variant</v-icon>
                                        {{ field.label }} {{ field.customfield ? '(CP)' : '' }}
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon 
                                                    v-if="field.always_required === true" 
                                                    color="error"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >mdi-asterisk</v-icon>
                                            </template>
                                            <span>Obbligatorio</span>
                                        </v-tooltip>
                                    </v-card-text>
                                </v-card>
                            </template>
                        </draggable>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3">
            <!-- Solo mobile: mobileDefaults arriva valorizzato solo dall'endpoint
                 mobile (sez. 6 del contratto). Rimette lo stato locale, il
                 salvataggio resta a mano come per la card. -->
            <v-btn v-if="mobileDefaults" text @click="restoreDefaults">
                Ripristina predefiniti
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveConfiguration">
                Salva Configurazione
            </v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
    import draggable from 'vuedraggable'
    import FieldRolePermissionsMixin from '@/mixins/FieldRolePermissionsMixin'

    export default {
        name: 'AdvancedFieldSelector',
        components: {
            draggable
        },

        mixins: [FieldRolePermissionsMixin],

        props: {
            modelDef: {
                type: String,
                required: true
            },
            templateData: {
                type: String,
                default: 'template_data'
            },
            info: {
                type: String,
                default: 'info'
            },
            mobile: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                tab: null,
                isLoaded: false,
                roles: [],
                groups: [],
                ungroupedFields: [],
                allFields: [], // Nuovo array per tutti i campi
                expandedFields: {},
                searchField: '', // Aggiunto campo di ricerca
                expandedGroups: {}, // Aggiungi questo per tenere traccia dei gruppi espansi
                settingsMenus: {}, // Menu impostazioni per ogni gruppo
                colorMenus: {}, // Menu color picker per ogni gruppo
                mobileDefaults: null, // predefinito mobile convertito (solo endpoint mobile), per "Ripristina predefiniti"
                mandatoryFields: [], // chiavi obbligatorie mobile (solo endpoint mobile): si comportano come always_required
                colorSwatches: [
                    ['#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6'], // Blues
                    ['#E8F5E9', '#C8E6C9', '#A5D6A7', '#81C784'], // Greens  
                    ['#FFF3E0', '#FFE0B2', '#FFCC80', '#FFB74D'], // Oranges
                    ['#FCE4EC', '#F8BBD0', '#F48FB1', '#F06292'], // Pinks
                    ['#F3E5F5', '#E1BEE7', '#CE93D8', '#BA68C8'], // Purples
                    ['#FFEBEE', '#FFCDD2', '#EF9A9A', '#E57373'], // Reds
                    ['#FFF8E1', '#FFECB3', '#FFE082', '#FFD54F'], // Yellows
                    ['#ECEFF1', '#CFD8DC', '#B0BEC5', '#90A4AE']  // Greys
                ],
                generalTypeDefaultText: 'Dalla tab Stati: il Predefinito, altrimenti il primo'
            }
        },

        computed: {
            endpointUrl() {
                return this.mobile ? 'settings/fields-mobile-model/' : 'settings/fields-model/'
            },
            availableFields: {
                get() {
                    const usedFieldIds = new Set([
                        ...this.ungroupedFields.map(f => f.id),
                        ...this.groups.flatMap(g => g.fields.map(f => f.id))
                    ])
                    return this.allFields.filter(field => !usedFieldIds.has(field.id))
                },
                set(value) {
                    // Il setter è necessario per il v-model ma non deve fare nulla
                }
            }
        },

        methods: {
            // Default deciso dalle impostazioni del general type (es. stato Predefinito
            // dei progetti): il backend ignora quello salvato qui, quindi non si modifica
            hasGeneralTypeDefault(field) {
                const originalField = this.allFields.find(f => f.id === field.id)
                return originalField?.default === 'general_type_default'
            },

            async loadConfiguration() {
                try {
                    const [fieldsResponse, rolesResponse] = await Promise.all([
                        this.axios.post(this.endpointUrl, {
                            model: this.modelDef,
                            template_data: this.templateData,
                            info: this.info
                        }),
                        this.axios.post('getoptionfields/', {model: 'Role', relation_field: 'name', key: 'text', value: 'value'})
                    ])

                    this.roles = this.roleItemsWithAll(rolesResponse.data.option_fields)
                    this.allFields = fieldsResponse.data.template_form_fields.fields.map(field => ({
                        id: field.unique_key || field.key,
                        key: field.key,
                        label: this.$trans(field.label),
                        required: field.required || false,
                        always_required: field.always_required || false,
                        // Valore di partenza dal backend, MAI toccato da applyMandatoryFlags:
                        // le serve per resettare il pool prima di ricalcolare gli asterischi a ogni
                        // chiamata (caricamento iniziale + N "Ripristina predefiniti"), altrimenti
                        // un asterisco assegnato una volta resta appiccicato al campo sbagliato.
                        baseAlwaysRequired: field.always_required || false,
                        customfield: field.customfield || false,
                        type: field.type,
                        default: field.default || null,
                        permissions: {
                            show: ['*'],
                            edit: ['*'],
                            show_exclude: false,
                            edit_exclude: false,
                            edit_empty_only: [],
                            edit_empty_only_exclude: false
                        }
                    }))

                    // Solo endpoint mobile (settings/fields-mobile-model): predefinito
                    // convertito per "Ripristina predefiniti" + chiavi sempre obbligatorie.
                    this.mobileDefaults = fieldsResponse.data.mobile_defaults || null
                    this.mandatoryFields = fieldsResponse.data.mandatory_fields || []

                    this.applyFieldsConfig(fieldsResponse.data.fields_form_configuration)

                    this.isLoaded = true
                } catch (error) {
                    console.error('Error loading configuration:', error)
                }
            },

            // Applica una configurazione (fields_form_configuration o mobile_defaults,
            // stessa forma) allo stato locale groups/ungroupedFields. Riusata sia dal
            // caricamento iniziale sia da "Ripristina predefiniti".
            applyFieldsConfig(fieldSettings) {
                this.groups = []
                this.ungroupedFields = []

                if (fieldSettings) {
                    if (fieldSettings.groups) {
                        this.groups = fieldSettings.groups.map(group => ({
                            id: group.id,
                            label: group.label,
                            order: group.order,
                            collapsible: group.collapsible || false,
                            collapsed_by_default: group.collapsed_by_default || false,
                            background_color: group.background_color || null,
                            fields: Object.entries(group.fields).map(([fieldId, fieldConfig]) => {
                                const originalField = this.allFields.find(f => f.id === fieldId)
                                return {
                                    id: fieldId,
                                    key: originalField?.key || fieldId,
                                    label: originalField?.label || fieldId,
                                    required: fieldConfig.required,
                                    order: fieldConfig.order,
                                    default: fieldConfig.default || null,
                                    always_required: fieldConfig.always_required || false,
                                    permissions: this.normalizeRolePermissions(fieldConfig.permissions),
                                    customfield: originalField?.customfield || false,
                                    type: originalField?.type || null
                                }
                            })
                        }))
                    }

                    if (fieldSettings.ungrouped_fields) {
                        this.ungroupedFields = Object.entries(fieldSettings.ungrouped_fields)
                            .map(([fieldId, fieldConfig]) => {
                                const originalField = this.allFields.find(f => f.id === fieldId)
                                return {
                                    id: fieldId,
                                    key: originalField?.key || fieldId,
                                    label: originalField?.label || fieldId,
                                    required: fieldConfig.required,
                                    default: fieldConfig.default || null,
                                    always_required: fieldConfig.always_required || false,
                                    permissions: this.normalizeRolePermissions(fieldConfig.permissions),
                                    customfield: originalField?.customfield || false,
                                    type: originalField?.type || null
                                }
                            })
                    }
                }

                this.applyMandatoryFlags()
            },

            // mandatory_fields (solo mobile) si comportano come always_required oggi solo
            // nella UI: niente cestino, niente checkbox Required sul campo che porta
            // l'asterisco (il blocco vero e proprio al salvataggio è per chiave, in
            // saveConfiguration, non su questo flag — vedi lì). L'obbligo è sulla key del
            // payload (contratto sez. 3), non su unique_key: se il form ha più campi con la
            // stessa key (es. intervento: operator/multiple_operator condividono key
            // operator_id) basta che UNO sia piazzato. Un solo campo per key porta
            // l'asterisco — quello già piazzato se c'è, altrimenti il primo del pool.
            applyMandatoryFlags() {
                // Reset dal valore del backend: questo metodo gira anche da "Ripristina
                // predefiniti", un asterisco assegnato alla chiamata precedente non deve
                // restare appiccicato a un campo che stavolta non lo porta più.
                this.allFields.forEach(field => {
                    field.always_required = field.baseAlwaysRequired
                })

                if (!this.mandatoryFields.length) return

                const matchesKey = (field, key) => field.key === key || field.id === key
                const placedFields = [
                    ...this.groups.flatMap(group => group.fields),
                    ...this.ungroupedFields
                ]

                this.mandatoryFields.forEach(key => {
                    const placed = placedFields.find(field => matchesKey(field, key))
                    if (placed) {
                        placed.always_required = true
                        return
                    }
                    const poolField = this.allFields.find(field => matchesKey(field, key))
                    if (poolField) {
                        poolField.always_required = true
                    }
                })
            },

            // Rimette il predefinito mobile nello stato locale: il salvataggio resta
            // a mano (pulsante "Salva Configurazione"), come per la card mobile.
            restoreDefaults() {
                if (!this.mobileDefaults) return
                this.applyFieldsConfig(this.mobileDefaults)
                this.$store.commit('setSnackbar', {
                    timeout: 5000,
                    text: 'Predefiniti ripristinati: premi "Salva Configurazione" per applicarli',
                    value: true,
                    color: 'info'
                })
            },

            cloneField(field) {
                return {
                    ...field,
                    id: field.id,
                    type: field.type,
                    default: field.default || null,
                    permissions: {
                        ...field.permissions,
                        show_exclude: false,
                        edit_exclude: false,
                        edit_empty_only: [],
                        edit_empty_only_exclude: false
                    }
                }
            },

            addNewGroup() {
                const newGroup = {
                    id: `group_${Date.now()}`,
                    label: 'Nuovo Gruppo',
                    order: this.groups.length + 1,
                    collapsible: false,
                    collapsed_by_default: false,
                    background_color: null,
                    fields: []
                }
                this.groups.push(newGroup)
                // Espandi automaticamente il nuovo gruppo
                this.$set(this.expandedGroups, newGroup.id, true)
            },

            // Modifica il metodo removeGroup per gestire il ritorno dei campi
            removeGroup(group) {
                const index = this.groups.indexOf(group)
                if (index > -1) {
                    // Rimuovi il gruppo ma non spostare i campi in ungroupedFields
                    this.groups.splice(index, 1)
                    // I campi torneranno automaticamente disponibili grazie al computed property
                }
            },

            // Aggiungi questo metodo per gestire la rimozione di un campo
            handleFieldRemoval(field, groupIndex) {
                if (groupIndex !== undefined) {
                    // Rimuovi dal gruppo
                    const group = this.groups[groupIndex];
                    const fieldIndex = group.fields.indexOf(field);
                    if (fieldIndex > -1) {
                        group.fields.splice(fieldIndex, 1)
                    }
                } else {
                    // Rimuovi dai campi non raggruppati
                    const fieldIndex = this.ungroupedFields.indexOf(field);
                    if (fieldIndex > -1) {
                        this.ungroupedFields.splice(fieldIndex, 1)
                    }
                }
                // Il campo tornerà automaticamente disponibile grazie al computed property
            },

            toggleExpand(field) {
                this.$set(this.expandedFields, field.id, !this.expandedFields[field.id])
            },
            
            isExpanded(field) {
                return Boolean(this.expandedFields[field.id])
            },

            toggleExpandGroup(group) {
                this.$set(this.expandedGroups, group.id, !this.expandedGroups[group.id])
            },
            
            isExpandedGroup(group) {
                return Boolean(this.expandedGroups[group.id])
            },

            updateOrders() {
                this.groups.forEach((group, index) => {
                    group.order = index + 1
                })
            },

            updateFieldOrder(group) {
                group.fields.forEach((field, index) => {
                    field.order = index + 1
                })
            },

            async saveConfiguration() {
                // Controllo per campo: gli always_required "di oggi" (dal backend,
                // baseAlwaysRequired) bloccano da soli se non piazzati.
                const missingByField = this.availableFields.filter(field => field.baseAlwaysRequired === true)

                // Controllo per chiave: mandatory_fields (solo mobile) è sulla key del
                // payload, non sul singolo campo — basta che UN campo piazzato (gruppi o
                // non raggruppati) abbia quella key (stesso match di applyMandatoryFlags).
                // Bloccato solo se NESSUNO la piazza; il messaggio nomina il campo del
                // pool con quella key (lo stesso che porta l'asterisco in UI).
                const matchesKey = (field, key) => field.key === key || field.id === key
                const placedFields = [
                    ...this.groups.flatMap(group => group.fields),
                    ...this.ungroupedFields
                ]
                const missingByKey = this.mandatoryFields
                    .filter(key => !placedFields.some(field => matchesKey(field, key)))
                    .map(key => this.allFields.find(field => matchesKey(field, key)))
                    .filter(field => field)

                const missingLabels = [...new Set([
                    ...missingByField.map(f => f.label),
                    ...missingByKey.map(f => f.label)
                ])]

                if (missingLabels.length > 0) {
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: `I seguenti campi obbligatori devono essere configurati: ${missingLabels.join(', ')}`,
                        value: true,
                        color: 'warning'
                    })
                    return
                }

                const configuration = {
                    groups: this.groups.map(group => ({
                        id: group.id,
                        label: group.label,
                        order: group.order,
                        collapsible: group.collapsible || false,
                        collapsed_by_default: group.collapsed_by_default || false,
                        background_color: group.background_color || null,
                        fields: group.fields.reduce((acc, field) => {
                            acc[field.id] = {
                                visible: true,
                                required: field.required,
                                always_required: field.always_required,
                                order: field.order,
                                default: field.default,
                                permissions: field.permissions
                            }
                            return acc
                            }, {})
                        })),
                    ungrouped_fields: this.ungroupedFields.reduce((acc, field) => {
                            acc[field.id] = {
                            visible: true,
                            required: field.required,
                            always_required: field.always_required,
                            order: field.order,
                            default: field.default,
                            permissions: field.permissions
                        }
                        return acc
                        }, {})
                    }

                try {
                    // Chiave dinamica basata su templateData e mobile
                    const mobileInfix = this.mobile ? '_mobile' : ''
                    const configKey = this.templateData !== 'template_data'
                        ? `fields_form${mobileInfix}_configuration_${this.templateData}`
                        : `fields_form${mobileInfix}_configuration`

                    await this.axios.post('settings/', {
                        model: this.modelDef,
                        [configKey]: configuration
                    })

                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: 'Configurazione salvata con successo',
                        value: true,
                        color: 'success'
                    })

                } catch (error) {
                    console.error('Error saving configuration:', error)
                }
            },

            matchesSearch(field) {
                if (!this.searchField) return true
                const searchTerm = this.searchField.toLowerCase()
                return field.label.toLowerCase().includes(searchTerm)
            },

            addAllFields() {
                const newFields = this.availableFields.map(field => this.cloneField(field))
                this.ungroupedFields.push(...newFields)
            },

            clearAllUngroupedFields() {
                this.ungroupedFields = []
            },
            
            // Helper per estrarre il valore hex dal background_color
            getBackgroundColorHex(background_color) {
                if (!background_color) return null
                
                // Se è già una stringa, usala direttamente
                if (typeof background_color === 'string') return background_color
                
                // Se è un oggetto, estrai la proprietà hex o hexa
                if (typeof background_color === 'object') {
                    return background_color.hex || background_color.hexa || null
                }
                
                return null
            },

            // Ottieni il valore corretto per il color picker
            getColorPickerValue(background_color) {
                if (!background_color) {
                    // Se non c'è colore, ritorna un colore di default (bianco)
                    return '#FFFFFF'
                }
                
                // Se è già una stringa hex, usala
                if (typeof background_color === 'string' && background_color.startsWith('#')) {
                    return background_color
                }
                
                // Se è un oggetto, estrai hexa o hex
                if (typeof background_color === 'object') {
                    return background_color.hexa || background_color.hex || '#FFFFFF'
                }
                
                return '#FFFFFF'
            },

            // Aggiorna il background_color del gruppo con il nuovo colore dal picker
            updateGroupBackgroundColor(group, colorValue) {
                // Il color picker restituisce un oggetto colore completo
                if (typeof colorValue === 'object') {
                    group.background_color = colorValue
                } else if (typeof colorValue === 'string') {
                    // Se per qualche motivo è una stringa, convertiamo in oggetto
                    group.background_color = {
                        alpha: 1,
                        hex: colorValue,
                        hexa: colorValue + 'FF'
                    }
                }
            },

            // Rimuovi il colore di background del gruppo
            removeGroupBackgroundColor(group) {
                group.background_color = null
                // Chiudi il menu del color picker
                if (this.colorMenus[group.id]) {
                    this.$set(this.colorMenus, group.id, false)
                }
            }
        },

        mounted() {
            this.loadConfiguration()
        }
    }
</script>

<style scoped>
    .group-container {
        min-height: 100px;
    }

    .group-fields-container  {
        min-height: 55px;
        background-color: rgb(245, 245, 245);
        margin: 12px;
        border-radius: 8px;
        border: 1px solid #ececec;        
    }

    .field-card {
        transition: all 0.3s ease;
    }

    .expand-content {
        transition: all 0.3s ease;
        overflow: hidden;
    }

    .expand-content.v-enter,
    .expand-content.v-leave-to {
        max-height: 0;
        opacity: 0;
    }

    .expand-content.v-enter-to,
    .expand-content.v-leave {
        max-height: 200px;
        opacity: 1;
    }

    .ghost-element {
        background: #BBDEFB !important; 
        opacity: 0.5;
    }

    .chosen-element {
        background: #BBDEFB !important; 
        opacity: 0.5;
    }    

    .drag-handle {
        cursor: move;
    }

    .no-drag {
        cursor: pointer;
    }

    .group-drag-handle {
        cursor: move;
        padding: 8px;
        margin-right: 8px;
    }

    .no-drag-input {
        pointer-events: auto !important;
        cursor: text !important;
        user-select: text !important;
        -webkit-user-drag: none !important;
    }

    .v-slide-y-transition {
        transition: all 0.3s ease;
    }
    
    /* Stili per il color picker e menu impostazioni */
    .flex-grow-1 {
        flex-grow: 1;
    }
    
    /* Animazioni per i menu */
    .v-menu__content {
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    }
    
    /* Badge per impostazioni attive */
    .v-badge__badge {
        animation: pulse 2s infinite;
    }
    
    @keyframes pulse {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
    
    /* Stile per il bottone colore */
    .v-btn--icon.no-drag {
        transition: all 0.2s ease;
    }
    
    .v-btn--icon.no-drag:hover {
        transform: scale(1.1);
    }
    
    /* Miglioramento visivo per i gruppi */
    .v-card-title {
        position: relative;
        overflow: visible;
    }
    
    /* Transizione smooth per color picker */
    .v-color-picker {
        transition: all 0.3s ease;
    }
    
    /* Tooltip wrapper style */
    .tooltip-wrapper {
        display: inline-block;
    }
    
    /* Miglioramento per dark mode */
    .theme--dark .group-fields-container {
        background-color: rgb(30, 30, 30);
        border-color: #424242;
    }
    
    /* Animazione per nuovi gruppi */
    @keyframes slideInFromTop {
        0% {
            transform: translateY(-20px);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: 1;
        }
    }
    
    .v-card:last-child {
        animation: slideInFromTop 0.3s ease;
    }
</style>
